import styled from 'styled-components'

import { Color } from 'constants/color'

export const Container = styled.div`
    display: flex;
    padding: 2em 2.5rem;
`

export const QRCodeComponentContainer = styled.div`
    display: flex;
    justify-content: center;
`

export const Information = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
`

export const Description = styled.div`
    display: flex;
    flex-direction: column;
`

export const LinkInfo = styled.div`
    display: flex;
    flex-direction: column;
`

export const Title = styled.h5`
    color: ${Color.ohGrey};
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    margin-top: 0;
    text-align: center;
    padding: 14px;
    padding-left: 28px;
    border-bottom: 1px solid ${Color.unknownColor17};
`

export const StepInfo = styled.p`
    color: ${Color.ohGrey};
    margin-bottom: 0.5em;
    font-weight: bold;
    text-align: center;
`

export const LinkInfoMessage = styled.p`
    color: ${Color.ohGrey};
    text-align: center;
    margin: 1em 0;
`

export const WhatsappLink = styled.span`
    color: #228bec;
    font-family: Avenir;
    font-weight: 700;
    cursor: pointer;
`
